"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "borghetto-di-borbera": {
    "a27aedc1": [{
      "hkey": "6b25d68c",
      "slug": "borghetto-di-borbera",
      "name": "Borghetto di Borbera",
      "primary": true,
      "skipSearch": false
    }],
    "costiolo": [{
      "hkey": "6b25d68c",
      "slug": "borghetto-di-borbera",
      "name": "Borghetto di Borbera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "0f41b0b6": [{
      "hkey": "6b25d68c",
      "slug": "borghetto-di-borbera",
      "name": "Borghetto di Borbera",
      "primary": true,
      "skipSearch": false
    }],
    "forneto": [{
      "hkey": "6b25d68c",
      "slug": "borghetto-di-borbera",
      "name": "Borghetto di Borbera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "668b8d7c": [{
      "hkey": "6b25d68c",
      "slug": "borghetto-di-borbera",
      "name": "Borghetto di Borbera",
      "primary": true,
      "skipSearch": false
    }],
    "monteggio": [{
      "hkey": "6b25d68c",
      "slug": "borghetto-di-borbera",
      "name": "Borghetto di Borbera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "7f2d1352": [{
      "hkey": "ce655c97",
      "slug": "torre-ratti-persi",
      "name": "Torre Ratti-Persi",
      "primary": true,
      "skipSearch": false
    }],
    "persi": [{
      "hkey": "ce655c97",
      "slug": "torre-ratti-persi",
      "name": "Torre Ratti-Persi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "borghetto-di-borbera"
    }],
    "b65b20d8": [{
      "hkey": "6b25d68c",
      "slug": "borghetto-di-borbera",
      "name": "Borghetto di Borbera",
      "primary": true,
      "skipSearch": false
    }],
    "sorli": [{
      "hkey": "6b25d68c",
      "slug": "borghetto-di-borbera",
      "name": "Borghetto di Borbera",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "79760fea": [{
      "hkey": "ce655c97",
      "slug": "torre-ratti-persi",
      "name": "Torre Ratti-Persi",
      "primary": true,
      "skipSearch": false
    }],
    "torre-ratti": [{
      "hkey": "ce655c97",
      "slug": "torre-ratti-persi",
      "name": "Torre Ratti-Persi",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;